import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 18V9.753c.44.399.779.909.972 1.488.65 1.949 3.406 1.949 4.055 0a3.5 3.5 0 0 1 2.214-2.214c1.949-.65 1.949-3.406 0-4.055A3.5 3.5 0 0 1 9.118 3H18a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H8a4 4 0 0 1-4-4m10-8a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1M8 20a1 1 0 1 1 0-2h10v2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 7.374a6 6 0 0 0-.61-.244.137.137 0 0 1 0-.26 5.5 5.5 0 0 0 3.48-3.48.137.137 0 0 1 .26 0 5.5 5.5 0 0 0 1.853 2.612 5.5 5.5 0 0 0 1.625.867.138.138 0 0 1 0 .261 5.5 5.5 0 0 0-2.393 1.588 5.5 5.5 0 0 0-1.085 1.89.138.138 0 0 1-.26 0 5.5 5.5 0 0 0-1.59-2.393A5.5 5.5 0 0 0 4 7.375"
    }
  )
);
var SvgPlaybookFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlaybookFilled_default = SvgPlaybookFilled;

export { PlaybookFilled_default as default };
